export default function Footer() {
  return (
    <footer className="bg-luxury-navy-900 border-t border-luxury-gold-800/30 py-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-400 text-sm">
            © 2024 Snap 3D Generator. All rights reserved.
          </div>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="/authentication-guide" className="text-gray-400 hover:text-white transition-colors text-sm">
              Authentication Guide
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
